<template>
  <div class="container">
    <bread-crumb :categorialeilao="leilao.categorialeilao" :nomeLeilao="leilao.nm" :nomeLote="lote.nu"></bread-crumb>
    <Stretch v-show="loadingPage == true">Carregando...</Stretch>
    <div v-if="naoEncontradoLoteAberto == true">
      <nao-encontrado :leilaoId="leilaoId" :cookie="cookie"></nao-encontrado>
    </div>
    <div v-else>
      <Stretch v-show="loadingPage == false && loadingLote == true">Carregando...
      </Stretch>
      <transition name="fade">
        <div v-show="loadingPage == false && loadingLote == false">
          <header-disputa :loteid="loteId" :leilaoid="leilaoId" :lotes="navegacao.lotes_combo" :lote="lote"
                          :loadingRefresh="loadingLote" :dadosLeilao="dadosLeilao"
                          :dadosModeradorId="dadosModeradorId"></header-disputa>

          <mensagem-box v-show="mostrarMesagem && loadingPage == false && loadingLote == false" :message="message"
                        :liberado="liberado" :usuario="usuario"></mensagem-box>

          <mensagem-box-leilao v-show="mostrarMesagem" :message_informativo="message_informativo"
                               :informativo="informativo"></mensagem-box-leilao>

          <botoes-rotas :dadosRequisicao="dadosRequisicao" :isFavorito="usuario.is_favorito"
                        :interesse="usuario.interesse"></botoes-rotas>
          <div style="float: right; height: 45px;" v-show="!leilao.bn_fechamentoautomatico && lote_id_pregao > 0">
            <span v-if="lote_id_pregao > 0">
              <router-link :to="{ name: 'LoteAberto' }" @click="loteClicado(lote_id_pregao)">
                <seguir-leiloeiro :firstLoadSalaDisputa="firstLoadSalaDisputa" :loadingRefresh="false"
                                  :lote_id_pregao="lote_id_pregao" :leilao="leilao" :seguir="seguir" tela="loteaberto"
                                  @seguirLeiloeiro="seguirLeiloeiro()">
                </seguir-leiloeiro>
              </router-link>
            </span>
            <span v-else>
              <seguir-leiloeiro :firstLoadSalaDisputa="firstLoadSalaDisputa" :loadingRefresh="false"
                                :lote_id_pregao="lote_id_pregao" :leilao="leilao" :seguir="seguir" tela="loteaberto"
                                @seguirLeiloeiro="seguirLeiloeiro()">
              </seguir-leiloeiro>
            </span>
          </div>

          <div class="clearfix"></div>
          <!-- COUNTEUDO LOTEABERTO -->
          <div class="lt-layout" id="target_scroll">
            <header class="lt-header" :style="`background:${statusLote.statusLoteBg}; opacity:0.7;`">
              <h2 class="col-md-4">Lote {{ lote.nu }}</h2>
              <h2 class="col-md-4 text-center" style="
                                border-radius: 3px;
                                padding-bottom: 9px;
                                margin-bottom: 0;
                                text-transform: uppercase;
                            ">
                {{ statusLote.statuslote }}
              </h2>
              <div class="header-navegacao col-md-4">
                <div class="product-details-box">
                  <div id="prevnext_lotes" class="product-nav-container"
                       v-if="!seguir && navegacao.lotes_combo !== undefined && leilao">
                    <div class="product-nav product-nav-prev">
                      <router-link :to="`/leilao/index/leilao_id/${leilaoId}/lote/${navegacao.link_anterior}`">
                        <i class="fa fa-chevron-left"></i>
                      </router-link>
                      <q></q>
                    </div>

                    <select v-model="linkCombo" title="selecionar lote" @change.prevent="loteClicado(linkCombo)">
                      <option v-for="(opt, idx) in navegacao.lotes_combo" :key="idx" :value="opt.id">
                        {{ opt.nu }}
                      </option>
                    </select>

                    <div class="product-nav product-nav-next">
                      <router-link :to="`/leilao/index/leilao_id/${leilaoId}/lote/${navegacao.link_proximo}`">
                        <i class="fa fa-chevron-right"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </header>
            <div class="lt-wrapper">
              <!-- SLIDE E AREA DE LANCE -->
              <div class="lt-fotos col-lg-7">
                <!-- FOTOS/LOTE -->
                <div v-if="(lote.fotos && lote.fotos[0]) || temVideo(lote)">
                  <thumb-slide :images="slides" :vistorias="lote.vistoria" :exibe_desocupado="false"/>
                </div>
                <div v-else>
                  <img class="img-fluid rounded" alt="lote imagem" style="width:100%"
                       src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/fotos/nao-disponivel.jpg"/>
                </div>
              </div>

              <div class="lt-lance col-lg-5">
                <area-lance :lote="lote" :historicoLances="historicoLances.length" :leilao="leilao"
                            :dadosLeilao="dadosLeilao" :lote_id_pregao="lote_id_pregao" :usuario="usuario"
                            :liberado="liberado"
                            :isfavorito="isfavorito" :lanceAtual="lanceAtual" :statusLote="statusLote"
                            :dt_fechamento_lote="dt_fechamento_lote" :liberacao_lote="liberacao_lote"
                            :paramsite_proposta="paramsite_proposta" :preferencia="preferenciaLance"/>
              </div>
              <!-- ////SLIDE E AREA DE LANCE -->
              <div class="clearfix"></div>
            </div>
            <div class="lt-wrapper lt-chat-abas">
              <div class="col-lg-7 lt-abas">
                <!-- TABS -->
                <tabs :options="{ useUrlFragment: false }">
                  <tab name="Descrição">
                    <h2 v-html="lote.nm_titulo"></h2>
                    <div class="style-descricao">
                      <p style="padding: 5px" v-html="lote.nm_descricao"></p>
                      <br/>
                      <br/>
                    </div>
                    <div class="role-descricao">
                      <span>Role a descrição para ver mais</span>
                    </div>
                  </tab>

                  <!-- Aba judicial -->
                  <tab :is-disabled="lote.judicial && lote.judicial.nu_processo !== ''
                    ? false
                    : true
                    " name="Proc. Jud.">
                    <div v-if="lote.judicial" class="judicial-tab">
                      <h2>Processo: {{ lote.judicial.nu_processo }}</h2>
                      <div style="overflow:auto; max-height: 200px;">
                        <p v-if="lote.judicial.nm_acao">
                          <strong>Ação:</strong>
                          <span>{{ lote.judicial.nm_acao }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_autor">
                          <strong>Autor:</strong>
                          <span>{{ lote.judicial.nm_autor }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_reu">
                          <strong>Réu:</strong>
                          <span>{{ lote.judicial.nm_reu }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_exequente">
                          <strong>Exequente:</strong>
                          <span>{{ lote.judicial.nm_exequente }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_executada">
                          <strong>Executada:</strong>
                          <span>{{ lote.judicial.nm_executada }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_juiz">
                          <strong>Juíz:</strong>
                          <span>{{ lote.judicial.nm_juiz }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_edital">
                          <strong>Edital:</strong>
                          <span>{{ lote.judicial.nm_edital }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_doe">
                          <strong>DOE:</strong>
                          <span>{{ lote.judicial.nm_doe }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_publicacao">
                          <strong>Publicação:</strong>
                          <span>{{ lote.judicial.nm_publicacao }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_vara">
                          <strong>Vara:</strong>
                          <span>{{ lote.judicial.nm_vara }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_praca">
                          <strong>Leilão:</strong>
                          <span>{{ lote.judicial.nm_praca }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_municipio">
                          <strong>Município:</strong>
                          <span>{{ lote.judicial.nm_municipio }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_comarca">
                          <strong>Comarca:</strong>
                          <span>{{ lote.judicial.nm_comarca }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_porcentagem">
                          <strong>Porcentagem:</strong>
                          <span>{{ lote.judicial.nm_porcentagem }}</span>
                        </p>
                        <p v-if="lote.judicial.nu_hasta">
                          <strong>Nº Hasta:</strong>
                          <span>{{ lote.judicial.nu_hasta }}</span>
                        </p>
                        <p v-if="lote.judicial.nm_observacao">
                          <strong>Observação:</strong>
                          <span v-html="lote.judicial.nm_observacao"></span>
                        </p>
                      </div>
                    </div>
                  </tab>
                  <!-- FIM aba judicial -->
                  <!-- Aba de anexos da vistoria/lote -->
                  <tab name="Anexos">
                    <span v-for="(vistoria, idv) in lote.vistoria" :key="idv">
                      <h2>Anexos relacionados:</h2>
                      <div style="overflow:auto; max-height: 200px;">
                        <span v-for="(anexo, ida) in vistoria.anexos" :key="ida">
                          <p>
                            <span>
                              <a title="Clique aqui para abrir o anexo" target="_blank"
                                 :href="`${anexo.nm_path_completo}`">
                                <h4 style="margin-top: 0px;">
                                  - {{ anexo.nm }}
                                </h4>
                              </a>
                            </span>
                          </p>
                        </span>
                      </div>
                    </span>
                  </tab>
                  <!-- FIM - aba de anexos da vistoria/lote -->

                  <!-- MENSAGENS LEILOEIRO -->
                  <tab name="Mensagens">
                    <mensagem :mensagens="mensagens" :usuario="usuario"
                              :paramsite_chatcomprador="paramsite_chatcomprador"></mensagem>
                  </tab>

                  <!-- Aba de Historico de lances -->
                  <tab name="Lances">
                    <div class="total-de-lances">
                      <h2>Lances cadastrados</h2>
                      <span class="count-lances">Quantidade total de lances: {{
                          historicoLances.length
                        }}</span>
                    </div>

                    <div class="table-container">
                      <div style="overflow:auto; width:100%; min-width: 600px;">
                        <table class="table-historico" cellspacing="0" cellspadding="0" border="0">
                          <tr>
                            <th style="width: 80px;">Data</th>
                            <th style="width: 70px;">Hora</th>
                            <th style="width: 120px;">Usuário</th>
                            <th style="width: 100px;">Lance(R$)</th>
                            <th style="width: 70px;">Forma Pgto.</th>
                            <th style="width: 100px;" v-if="lote.nu_intervaloparcelaslote == 5">
                              Entrada (%)
                            </th>
                            <th style="width: 100px;" v-if="temPreferencial">Preferência</th>
                            <th style="width: 30px;"></th>
                          </tr>
                        </table>
                      </div>
                      <div style="overflow:auto; width:100%; min-width: 600px; max-height: 200px;">
                        <table class="table-historico" cellspacing="0" cellspadding="0" border="0">
                          <tbody>
                          <tr v-for="(historico, idx) in historicoLances" :key="idx">
                            <td style="width: 80px;">{{ historico.data_formatada }}</td>
                            <td style="width: 70px;">{{ historico.hora_formatada }}</td>
                            <td style="width: 120px;">{{ historico.nm_apelido }}</td>
                            <td style="width: 100px;">{{ $root.formatarPreco(historico.vl) }}</td>
                            <td style="width: 70px;">
                              {{
                                historico.nu_parcelas == 1 || !historico.nu_parcelas ? "à vista" : historico.nu_parcelas + "x"
                              }}
                            </td>
                            <td style="width: 100px;" v-if="lote.nu_intervaloparcelaslote == 5">
                              {{ historico.vl_percentualentrada == 0 ? '--' : historico.vl_percentualentrada }}
                            </td>
                            <td style="width: 100px;" v-if="temPreferencial">{{
                                historico.nm_apelido_preferencia == true ? "Sim" : "Não"
                              }}
                            </td>
                            <td style="width: 30px;">{{ historico.bn_automatico == 1 ? "(A)" : "" }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </tab>
                  <tab name="Street View" v-if="iframeStreetView && iframeStreetView !== '-'">
                    <div class="street-view">
                      <div class="iframe-container" v-html="iframeStreetView"></div>
                    </div>
                  </tab>
                  <!-- FIM - aba histórico de lances -->
                </tabs>
              </div>
              <div class="col-lg-5 lt-chat">
                <div v-if="leilao.nm_linkyoutube" class="box-video">
                  <div style="display: none">
                    {{ (link_video = formataLinkVideo(leilao.nm_linkyoutube)) }}
                  </div>
                  <div v-if="leilao.nm_linkyoutube">
                    <iframe width="100%" height="315"
                            :src="`https://www.youtube.com/embed/${leilao.nm_linkyoutube}?autoplay=1`"
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen>
                    </iframe>
                  </div>
                </div>
                <div class="" v-else-if="leilao.nm_linktransmissao">
                  <div>
                    <iframe height="350px" width="100%" :src="leilao.nm_linktransmissao" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                  </div>
                </div>
              </div>
              <div class="col-lg-12" style="padding:0;" v-if="lotesRepasse.length > 0">
                <!-- LOTES EM REPASSE -->
                <div class="repasse-area">
                  <div class="div_descr">
                    <h4 class="title-h">Lotes (repasse \ repasse com lances)</h4>
                    <div class="base-tagcolor">
                      <span class="baasesapanqdcolor"><span class="qdcolor repassebg"></span>repasse</span>
                      <span class="baasesapanqdcolor"><span class="qdcolor repasselances"></span>repasse com
                        lances</span>
                    </div>
                  </div>
                  <div class="lotes-repasse">
                    <div v-for="(repasse, lote_id) in lotesRepasse" :key="lote_id"
                         :class="(repasse.statuslote_id === 11) ? 'repasse repasselances' : 'repasse'">
                      <router-link :to="'/leilao/index/leilao_id/' +
                        repasse.leilao_id +
                        '/lote/' +
                        repasse.id
                        " @click="loteClicado(repasse.id)">
                        <p>
                          <strong>Lote:</strong>
                          <span>{{ repasse.nu }}</span>
                        </p>
                      </router-link>
                    </div>
                    <div v-if="lotesRepasse">
                      <div v-show="lotesRepasse.length <= 0"
                           class="nenhum-lote heading heading-border heading-middle-border heading-middle-border-center">
                        <h1 class="heading-secondary" style="background: rgb(242, 242, 242); margin-top: 17px;">
                          Nenhum lote em repasse
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12" style="padding:0;" v-if="lotesRetirados.length > 0">
                <!-- LOTES EM RETIRADO -->
                <div class="repasse-area">
                  <div class="div_descr">
                    <h4 class="title-h">Lotes (retirados \ excluidos \ cancelados)</h4>
                    <div class="base-tagcolor">
                      <span class="baasesapanqdcolor"><span class="qdcolor retirado"></span>retirados</span>
                      <span class="baasesapanqdcolor"><span class="qdcolor excluidos"></span>excluidos</span>
                      <span class="baasesapanqdcolor"><span class="qdcolor cancelados"></span>cancelados</span>
                    </div>
                  </div>
                  <div class="lotes-repasse">
                    <div v-for="(rt, lote_id) in lotesRetirados" :key="lote_id" class="repasse"
                         :class="(rt.statuslote_id === 15) ? 'repasse excluidos' : (rt.statuslote_id === 13) ? 'repasse cancelados' : 'retirado'">
                      <router-link :to="'/leilao/index/leilao_id/' +
                        rt.leilao_id +
                        '/lote/' +
                        rt.id
                        " @click="loteClicado(rt.id)">
                        <p>
                          <strong>Lote:</strong>
                          <span>{{ rt.nu }}</span>
                        </p>
                      </router-link>
                    </div>
                    <div v-if="lotesRetirados">
                      <div v-show="lotesRetirados.length <= 0"
                           class="nenhum-lote heading heading-border heading-middle-border heading-middle-border-center">
                        <h1 class="heading-secondary" style="background: rgb(242, 242, 242); margin-top: 17px;">
                          Nenhum lote retirado
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import {Stretch} from "vue-loading-spinner";
import ThumbSlide from "@/components/thumbSlide/ThumbSlide";

//LAYOUT COMPONENT
import BreadCrumb from "@/components/shared/BreadCrumb";
import AreaLance from "@/components/shared/AreaLance";
import BotoesRotas from "@/components/shared/BotoesRotas";
import NaoEncontrado from "@/components/shared/NaoEncontrado";
import HeaderDisputa from "@/components/shared/HeaderDisputa";
import MensagemBox from "@/components/shared/MensagemBox";
import MensagemBoxLeilao from "@/components/shared/MensagemBoxLeilao";
import Mensagem from "@/components/shared/Mensagem";
import {Tab, Tabs} from "vue-tabs-component";
import SeguirLeiloeiro from "@/components/shared/SeguirLeiloeiro";

let interval = null;

export default {
  props: ["dadosLeilao", "dadosModeradorId"],
  components: {
    AreaLance,
    BreadCrumb,
    Stretch,
    NaoEncontrado,
    BotoesRotas,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao,
    Mensagem,
    SeguirLeiloeiro,
    Tabs,
    ThumbSlide,
    Tab
  },
  data() {
    return {
      leilao: [],
      lote: [],
      lotesGerais: [],
      dados_condicao: [],
      usuario: {
        id: null,
        interesse: [],
        is_favorito: false
      },
      config_leiloeiro: [],
      navegacao: [],
      historicoLances: [],
      statusLote: {
        statuslote: "status",
        statusLoteBg: "",
        statuslote_id: -1,
        statusliberacaolote_id: ""
      },
      dadosRequisicao: {isLogado: false, countLote: 0},
      lotesRepasse: [],
      lotesRetirados: [],
      mensagens: [],
      paramsite_chatcomprador: [],
      paramsite_comitente: [],
      paramsite: [],
      paramsite_proposta: [],
      lanceAtual: {
        vl_lance: 0.0,
        nm_apelido: null,
        vl_lance_sugerido: 0.0,
        nu_parcelas: 1
      },
      leilaoId: this.$route.params.id,
      loteId: this.$route.params.idlote,
      cookie: false,
      loadingPage: true,
      loadingLote: true,
      naoEncontradoLoteAberto: false,
      refreshCountLoteAberto: 30000,
      linkCombo: this.$route.params.idlote,
      errors: [],
      message: "",
      liberado: false,
      message_informativo: "",
      informativo: false,
      fechamento: false,
      isfavorito: false,
      interesse: [],
      index: 0,
      slides: [],
      vistorias: [],
      saladisputa: null,
      refLanceAtual: null,
      refStatus: null,
      refMensagens: null,
      refIncremento: null,
      dt_fechamento_lote: 0,
      liberacao_lote: true,
      countLote: null,
      /*seguir leiloeiro*/
      firstLoadSalaDisputa: true,
      lote_id_pregao: -1,
      seguir: false,
      mostrarMesagem: false,
      statusModerador: null,
      preferencia: [],
      preferenciaLance: false,
    };
  },
  methods: {
    temVideo(lote) {
      if (!lote || !lote.vistoria || !Array.isArray(lote.vistoria)) {
        return false;
      }
      return lote.vistoria.some(
        vistoria => vistoria.v_nm_youtube || vistoria.e_nm_youtube || vistoria.i_nm_youtube
      );
    },
    formataLinkVideo(link) {
      if (link.search("youtube") > 0) {
        this.tipo_video = "youtube";
        return link.replace(/(.*?=)([\w-]+)&?(.*?)?$/g, "$2") + "?autoplay=1;";
      } else if (link.search("vimeo") > 0) {
        this.tipo_video = "vimeo";
        return link.replace(/(.*?)([\d]+)$/g, "$2");
      }
    },
    clickItem(i) {
      this.index = i;
    },
    async loteClicado(id) {
      const targetRoute = `/leilao/index/leilao_id/${this.leilaoId}/lote/${id}`;
      // Atualize o estado independentemente da navegação
      this.selecionar_lote = true
      this.loteId = id;
      this.linkCombo = id;
      this.historicoLances = [];
      sessionStorage.setItem("loteId", id);
      this.$parent.$emit("statusloteClicado", true);
      this.$parent.$emit("loteIdAtualChange", id);
      await this.acompanhaLotePregao();

      if (this.$route.fullPath !== targetRoute) {
        try {
          await this.$router.push(targetRoute);
        } catch (err) {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        }
      }
    },
    callInfoAfterRoute(leilaoid, loteid) {
      this.loadingLote = true;

      this.leilaoId = leilaoid;
      this.loteId = loteid;

      // zera refresh incremento
      this.refIncremento = null;

      this.acompanhaMensagens(); // acompanha chat
      this.acompanhaStatus(); // acompanha status
      this.refreshDadosGerais(this); // refresh ec2
      this.refreshLote(false); // acompanha lote

      //Verifica lote empregão ao trocar de lote
      this.acompanhaLotePregao(); //acompanha lote em pregão
      this.firstLoadSalaDisputa = false;
      this.loadingPage = false;
      this.loadingLote = false;
    },

    acompanhaLanceAtual() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refLanceAtual != null) {
        this.refLanceAtual.off();
        this.lanceAtual.vl_lance = 0.0;
        this.lanceAtual.nm_apelido = null;
        this.lanceAtual.vl_lance_sugerido = 0.0;
        this.lanceAtual.nu_parcelas = 1;
      }

      this.refLanceAtual = db.ref(`/lance/${this.leilaoId}/${this.loteId}`);
      this.refLanceAtual.once("value", function (data) {
        if (data.val() == null) {
          // nenhum lance
          if (!self.refIncremento) {
            self.acompanhaIncremento();
          }
        }
      });

      this.refLanceAtual
        .orderByChild("id")
        .limitToLast(1)
        .on("child_added", function (data) {
          self.lanceAtual.vl_lance = data.val().vl;
          self.lanceAtual.nm_apelido = data.val().nm_apelido;
          self.lanceAtual.nu_parcelas = data.val().nu_parcelas;
          self.lanceAtual.vl_lance_sugerido =
            parseFloat(data.val().vl) + parseFloat(self.lote.raw_incremento);

          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(self.lanceAtual.vl_lance_sugerido);

          self.acompanhaHistoricoLances();
          if (!self.refIncremento) {
            self.acompanhaIncremento();
          }
        });

      this.refLanceAtual.on("child_removed", function (data) {
        self.refLanceAtual.once("value", function (snapshot) {
          if (!snapshot.exists()) {
            self.lanceAtual.vl_lance = 0.0;
            self.lanceAtual.nm_apelido = null;
            self.lanceAtual.vl_lance_sugerido = 0.0;
            self.lanceAtual.nu_parcelas = 1;
            self.acompanhaIncremento();
            self.acompanhaHistoricoLances();
          }
        });
      });
    },

    acompanhaHistoricoLances() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      function addHours(numOfHours, date = new Date()) {
        date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
        return date;
      }

      this.historicoLances = [];
      db.ref(`/lance/${this.leilaoId}/${this.loteId}`)
        .orderByChild("id")
        .once("value")
        .then(function (data) {
          if (data.val()) {
            var registros = Object.values(data.val());

            registros.forEach(function (reg) {
              const dt_split = reg.data_formatada.split("/");
              const dt_formatada = dt_split[2] + "-" + dt_split[1] + "-" + dt_split[0];
              const date = new Date(dt_formatada + 'T' + reg.hora_formatada);

              if (self.leilao.statusfusohorario_id) {
                const dt = addHours(self.leilao.statusfusohorario_id, date);
                reg.hora_formatada = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2) + ":" + ("0" + dt.getSeconds()).slice(-2);
              }

              reg.nm_apelido_preferencia = false;

              if (self.preferencia.length && self.preferencia.includes(reg.nm_usuario_id)) {
                reg.nm_apelido_preferencia = true;
              }

              if (!self.historicoLances.some(r => r.id === reg.id)) {
                self.historicoLances.unshift(reg);
              }
            });
          }
        });
    },

    acompanhaStatus() {
      // Firebase database reference
      var db = this.firebase_db;
      var self = this;

      if (this.refStatus != null) {
        this.refStatus.off();
      }

      this.refStatus = db.ref(`/status/${this.leilaoId}/${this.loteId}`);
      this.refStatus.on("value", function (data) {
        self.statusLote.statuslote = data.val().statuslote;
        self.statusLote.statusLoteBg = data.val().statusLoteBg;
        self.statusLote.statusliberacaolote_id = data.val().statusliberacaolote_id;
        self.liberacao_lote = true;

        if (self.statusLote.statusliberacaolote_id !== undefined) {
          if (self.statusLote.statusliberacaolote_id !== 2) {
            self.liberacao_lote = false;
          }
        }
      });
    },

    acompanhaIncremento() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refIncremento != null) {
        this.refIncremento.off();
      }

      this.refIncremento = db.ref(
        `/incremento/${this.leilaoId}/${this.loteId}`
      );
      this.refIncremento.on("value", function (data) {
        self.lote.raw_incremento = data.val().raw_incremento;
        var lancesuregido = 0;

        //Novo: Verifcando se existe lance no nó de lance do firebase e nao no nó de lote onde nao está sendo atualizado o valor do ultimo lance em realtime.
        if (self.lanceAtual.vl_lance > 0) {
          //Lote com lance
          lancesuregido =
            parseFloat(self.lanceAtual.vl_lance) +
            parseFloat(self.lote.raw_incremento);
        } else {
          //Sem lance
          if (self.lote.vl_lanceinicial <= 0) {
            lancesuregido = parseFloat(self.lote.raw_incremento);
          } else {
            lancesuregido = parseFloat(self.lote.vl_lanceinicial);
          }
        }

        self.lanceAtual.vl_lance_sugerido = lancesuregido;
        if (self.leilao.statusleilao_id == 13) {
          //Venda direta precisa retirar o R$
          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(lancesuregido).replace("R$ ", "");
        } else {
          document.querySelector(
            "#enviar_lance_manual_val"
          ).value = self.$root.formatarPreco(lancesuregido);
        }
      });
    },

    acompanhaMensagens() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      function addHours(numOfHours, date = new Date()) {
        date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
        return date;
      }

      if (this.refMensagens != null) {
        this.refMensagens.off();
      }

      this.mensagens = [];
      this.refMensagens = db.ref(`/mensagem/${this.leilaoId}/${this.loteId}`);
      this.refMensagens.on("child_added", function (datas) {
        $("[aria-controls='#mensagens']").addClass("fa-blink");

        const reg = datas.val();
        const date = new Date();
        date.setHours(reg.data.split(":")[0], reg.data.split(":")[1], reg.data.split(":")[2]);

        if (!!self.leilao.statusfusohorario_id) {
          const dt = addHours(self.leilao.statusfusohorario_id, date);
          reg.data = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2) + ":" + ("0" + dt.getSeconds()).slice(-2);
        }

        self.mensagens.push(reg);
      });

      this.refMensagens.on("child_removed", function (data) {
        var idx = self.mensagens.findIndex(m => (m.id = data.id));
        self.mensagens.splice(idx, 1);
      });
    },

    acompanhaRepasse() {
      var self = this;
      self.lotesRepasse = [];

      for (let i in self.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 11 || statusLoteId === 6) {
          let loteRepasse = {...self.lotesGerais[i], statuslote_id: statusLoteId};
          self.lotesRepasse.push(loteRepasse);
        }
      }
    },

    acompanhaRetirado() {
      const self = this;
      this.lotesRetirados = [];

      for (let i in this.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 15 || statusLoteId === 13 || statusLoteId === 10) {
          let loteRetirado = {...this.lotesGerais[i], statuslote_id: statusLoteId};
          this.lotesRetirados.push(loteRetirado);
        }
      }
    },
    async refreshDadosGeraisHeader() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const token = window.localStorage.getItem('token');
      this.preferenciaLance = false;

      const headers = {};

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      try {
        const res = await fetch(`${hostName}/leilao/get-dados-header-disputa?leilao_id=${this.leilaoId}&lote_id=${this.loteId}`, {
          method: 'GET',
          headers
        });

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();

        this.lotesGerais = data.navegacao.lotes_gerais;
        this.preferencia = data.usuario_preferencia;

        if (this.lotesGerais) {
          this.acompanhaRepasse();
          this.acompanhaRetirado();
        }

        if (this.preferencia.length && this.preferencia.includes(this.usuario.id)) {
          this.preferenciaLance = true;
        }


        this.loadingPage = false;
        this.loadingLote = false;
      } catch (error) {
        console.error('Erro ao buscar dados do header:', error);
      }
    },

    refreshDadosGerais(childSelf) {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;

      // lanceautomatico e usuario (favorito)
      fetch(
        `${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}&lote_id=${this.loteId}`
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          this.lote.vl_lanceautomatico = res.vl_lanceautomatico;
          this.usuario = res.usuario;
          this.dadosRequisicao.isLogado =
            this.usuario.id !== null ? true : false;

          if (this.lote.vl_lanceautomatico > 0) {
            this.lote.vl_lanceautomatico = self.$root.formatarPreco(
              this.lote.vl_lanceautomatico
            );
          }

          this.navegacao = res.navegacao;
          this.isfavorito = res.usuario.is_favorito;
        });
    },

    refreshCronometroLote() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      db.ref(`/dtfechamento/${this.leilaoId}/${this.loteId}`).on(
        "value",
        function (data) {
          if (data.val()) {
            self.fechamento = data.val();
            self.dt_fechamento_lote = self.fechamento.dt_fechamento;
          } else {
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            self.dt_fechamento_lote = date + ' ' + time;
          }
        }
      );
    },

    refreshLote(dt = true) {
      // firebase
      var db = this.firebase_db;
      var self = this;
      db.ref(`/lote/${this.leilaoId}`)
        .once("value")
        .then((data) => {
          this.dadosRequisicao.countLote = Object.values(data.val())
        })

      db.ref(`/lote/${this.leilaoId}/${this.loteId}`).once("value", function (
        data
      ) {
        self.lote = data.val();
        self.acompanhaLanceAtual();

        //slides
        self.slides = [];
        if (self.lote.fotos != undefined) {
          self.lote.fotos.map((item, idx) => {
            self.slides.push({
              id: idx,
              big: `${item.nm_path_incompleto}${item.tamanho.thumb_grande}/${item.nm_path}`,
              thumb: `${item.nm_path_incompleto}${item.tamanho.thumb}/${item.nm_path}`
            });
          });
        }
        document.querySelector("#btn_loteaberto").className =
          "router-link-exact-active router-link-active";
      });

      if (dt) {
        //Atualiza cronometro do lote aberto;
        this.refreshCronometroLote();
      }
    },

    acompanhaLotePregao() {
      const self = this;

      var db = this.firebase_db;

      if (self.seguir) {
        self.acompanhaHistoricoLances();
      }

      if (self.lote_id_pregao > 0 && self.seguir) {
        db.ref(`/lote/${self.leilaoId}/${self.lote_id_pregao}`).once("value", function (data) {
          self.lote_pregao = data.val();
        })
      }
    },
    seguirLeiloeiro(ev) {
      this.seguir = !this.seguir;
      if (this.leilao && !this.leilao.bn_fechamentoautomatico) {
        if (this.seguir) {
          this.loteClicado(this.leilao.statuslotemoderador_id);
        }
      }
      this.acompanhaLotePregao();
    },
  },
  created() {
    // dados vindo do props
    this.leilao = this.dadosLeilao
    this.statusModerador = this.dadosModeradorId

    this.saladisputa = new window.saladisputa(this);
    clearInterval(window.INTERVALO_BUSCA);
    clearInterval(window.INTERVALO_CATEGORIA);

    const self = this;

    const hostName = location.protocol + "//" + window.HOSTNAME;
    fetch(`${hostName}/leilao/salva-visita/lote_id/${this.loteId}`);

    this.$on("dados-gerais", function (data) {
      this.config_leiloeiro = data.config_leiloeiro;
      this.dados_condicao = data.dados_condicao;
      this.usuario = data.usuario;
      this.isfavorito = data.usuario.is_favorito;
      this.lote.vl_lanceautomatico = data.vl_lanceautomatico;
      this.navegacao = data.navegacao;
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false;

      if (this.lote.vl_lanceautomatico > 0) {
        this.lote.vl_lanceautomatico = self.$root.formatarPreco(
          this.lote.vl_lanceautomatico
        );
      }

      // CONFIG AUTO RELOAD
      if (this.usuario.id !== null) {
        sessionStorage.setItem(
          "isLogado",
          this.usuario.id !== null ? true : false
        );
      }
    });

    this.$on("callDadosGerais", function () {
      self.refreshDadosGerais();
    });

    this.$on("liberacaoMensagem", function (json) {
      this.message = json.message;
      this.liberado = json.liberado;
      this.fechamento = json.fechamento;
      this.message_informativo = json.message_informativo;
      this.informativo = json.informativo;
      this.mostrarMesagem = json.mostrarMesagem
    });

    this.$on("addFavorito", function (data) {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const self = this;

      let urlRequest = this.isfavorito ? "exclui-favorito" : "add-favorito";

      this.isfavorito = !this.isfavorito;

      fetch(`${hostName}/leilao/${urlRequest}?lote_id=${this.lote.lote_id}&usuario_id=${this.usuario.id}`)
        .then((res) => {
          if (!res.ok) {
            return res.json().then((error) => {
              throw new Error(`Erro: ${error.msg}`);
            });
          }
          return res.json();
        })
        .then(function (response) {
          alert(response.msg);
          self.isFavorito = !self.isFavorito;
          self.refreshDadosGerais(self);
        })
        .catch(function (error) {
          alert("Erro inesperado: " + error.message);
          console.log(error);
        });
    });

    //verifica cookie e browser
    this.cookie = this.$root.cookieAtivo;
    this.$root.MensagemBrowserCookie();


    var db = this.firebase_db;

    //Nó paramsite do firebase
    db.ref(`/paramsite/`).once("value", function (data) {
      $.each(data.val(), function (key, value) {
        //Chat comprador
        if (value && value.statusparamsite_id == 71) {
          self.paramsite_chatcomprador = value;
        }
        //Exibição de comitente na vistoria
        if (value && value.statusparamsite_id == 72) {
          self.paramsite_comitente = value;
        }
        //Alteração de label de venda direta para proposta
        if (value && value.statusparamsite_id == 74) {
          self.paramsite_proposta = value;
        }
      });
    });

    // registra visita
    this.acompanhaMensagens(); // acompanha chat
    this.acompanhaStatus(); // acompanha status
    this.acompanhaLotePregao(); //acompanha lote em pregão
    this.refreshLote(); // acompanha lote

    this.refLiberacaoParcelamento = db.ref(`/lote/${this.leilaoId}/${this.loteId}/vl_liberaparcelamento`);
    this.refLiberacaoParcelamento.on("value", (snapshot) => {
      const novoValor = snapshot.val();
      this.lote.vl_liberaparcelamento = novoValor;
    });
  },
  mounted() {
    const logo = document.querySelector('img[alt="Logo"]');
    if (logo) {
      logo.addEventListener('click', function (event) {
        event.preventDefault();

        sessionStorage.removeItem('filtrosLotes');

        Object.keys(sessionStorage).forEach(function (key) {
          if (key.startsWith('cacheFiltros:tipo')) {
            sessionStorage.removeItem(key);
          }
        });

        window.location.href = "/";
      });
    } else {
      console.warn('Logo não encontrado no DOM');
    }
  },
  beforeUpdate() {
    //Atualiza cronometro do lote aberto;
    this.refreshCronometroLote();

    const messagem = document.querySelector("[aria-controls='#mensagens']");
    if (messagem) {
      messagem.addEventListener("click", () => {
        messagem.classList.remove("fa-blink");
      });
    }

    setTimeout(() => {
      if (this.$refs.titleLength) {
        if (this.$refs.titleLength.innerHTML.length > 40) {
          this.$refs.titleLength.setAttribute(
            "style",
            "font-size:20px !important"
          );
        }
      }

      if (this.$refs.precoLength) {
        const len = this.$refs.precoLength.innerHTML.length;

        if (len > 13 && len <= 16) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:30px !important"
          );
        } else if (len > 16 && len <= 18) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:28px !important"
          );
        } else if (len > 18) {
          this.$refs.precoLength.setAttribute(
            "style",
            "font-size:22px !important"
          );
        }
      }
    }, 500);
  },
  computed: {
    temPreferencial() {
      return this.historicoLances.some(h => h.nm_apelido_preferencia === true);
    },
    iframeStreetView() {
      if (!this.lote || !Array.isArray(this.lote.vistoria)) {
        console.warn('⚠️ lote.vistoria ainda não está disponível ou não é array.');
        return null;
      }

      const vistoriaComIframe = this.lote.vistoria.find(v => v.iframe_streetview);

      return vistoriaComIframe ? vistoriaComIframe.iframe_streetview : null;
    }
  },
  watch: {
    '$route.params.idlote': {
      handler(newId) {
        this.loteClicado(newId)
      },
      immediate: true
    },
    $route(to, from) {
      const self = this;
      this.callInfoAfterRoute(self.$route.params.id, self.$route.params.idlote);
    },
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    },
    'statusLote.statuslote'(novo, antigo) {
      this.refreshDadosGeraisHeader()
    },
    'dadosModeradorId'(novo, ant) {
      this.statusModerador = this.dadosModeradorId
      this.lote_id_pregao = novo.items[0].statuslotemoderador_id
      if (this.seguir) {
        this.loteClicado(this.lote_id_pregao);
      }
    },
    "lote"() {
      this.refreshDadosGerais();
      this.refreshDadosGeraisHeader();
    },
    "preferencia"() {
      this.preferencia = this.preferencia
      this.acompanhaHistoricoLances()
    }
  }
};
</script>
<style>
.router-link-exact-active .router-link-active {
  cursor: no-drop !important;
}

@keyframes fa-blink {
  0% {
    opacity: 1;
    color: white;
    background: #67302b;
  }

  50% {
    opacity: 0.6;
    color: white;
    background: #67302b;
  }

  100% {
    opacity: 1;
    color: white;
    background: #67302b;
  }
}

.fa-blink {
  -webkit-animation: fa-blink 1.4s linear infinite;
  -moz-animation: fa-blink 1.4s linear infinite;
  -ms-animation: fa-blink 1.4s linear infinite;
  -o-animation: fa-blink 1.4s linear infinite;
  animation: fa-blink 1.4s linear infinite;
}


/* zoom slide */
.zoom-product-img .thumb-list {
  width: 26% !important;
  margin-top: -12px;
  margin-bottom: 15px;
  display: inline-box;
  display: -webkit-inline-box;
}

.zoom-product-img .text-right {
  float: right !important;
}

.zoom-product-img .fa {
  font-size: 30px;
}

/* EFEITO DE TRANSIÇÃO */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ESTILO LOTEABERTO - LAYOUT */
#portotemplate {
  background: #f2f2f2;
}

.lt-layout {
  margin-bottom: 20px;
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  color: #333;
}

.lt-wrapper {
  min-height: 200px;
  background: #fff;
  border-bottom: 1px solid #ddd;
}

.lt-header {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid #908b8b;
}

.lt-header h2 {
  padding: 15px 15px 0;
  font-weight: 700 !important;
  color: #fff !important;
}

#prevnext_lotes {
  margin-top: 16px;
}

#portotemplate .product-details-box .product-nav-container .product-nav a {
  color: #fff !important;
}

#portotemplate .product-details-box .product-nav-container .product-nav a:hover {
  color: #000 !important;
}

.lt-fotos {
  border-right: 1px solid #ddd;
  min-height: 100px !important;
  padding-top: 15px;
}

.lt-chat {
  padding: 0 !important;
  border-left: 1px solid #ddd;
}

.lt-fotos .control {
  font-size: 40px !important;
}

.lt-lance {
  padding: 32px !important;
}

.add-favorito {
  text-align: right;
  font-size: 20px;
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  color: #67302b;
  border-radius: 30px;
  padding: 6px 4px 4px 6px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.style-descricao {
  overflow: auto;
  max-height: 200px;
}

// Ativa efeito do scroll-bar
/*.style-descricao::-webkit-scrollbar {
  width: 10px !important;
}

.style-descricao::-webkit-scrollbar-thumb {
  background: #67302b !important;
  border-radius: 5px !important;
}

.style-descricao::-webkit-scrollbar-track {
  background: transparent;
}

!* arrow down *!
.style-descricao::-webkit-scrollbar-button:increment {
  width: 10px;
  height: 10px;
  border-left: 25px solid transparent;
  //border-right: 25px solid transparent;
  border-bottom: 25px solid #67302b;
}

!* arrow up *!
.style-descricao::-webkit-scrollbar-button:decrement {
  width: 10px;
  height: 10px;
  //border-left: 25px solid transparent;
  border-left: 25px solid transparent;
  border-top: 25px solid #67302b;
}*/

.envia_limite_lance {
  padding: 2px 6px;
  background: #cccbcb;
  border-radius: 14px;
  cursor: pointer;
  border: 1px solid #afadad;
}

.lt-abas {
  padding: 0 !important;
  margin: -0.01%;
}

.tabs-component,
.repasse-area {
  padding: 20px;
}

.repasse-area {
  border-top: 1px solid #ddd;
}

.repasse-area h4 {
  color: #633834 !important;
  font-weight: 600 !important;
}

.lotes-repasse {
  max-height: 270px;
  overflow: auto;
}

.repasse a {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.repasse a p {
  margin: 0 !important;
}

.repasse {
  margin: 2px;
  width: 80px;
  display: inline-block;
  border-radius: 3px;
  text-align: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  background: rgb(11, 78, 40);
  justify-content: center;
  height: 60px;
}

.repassebg {
  background: rgb(11, 78, 40);
}

.repasselances {
  background: rgb(3, 69, 118) !important;
}

.cancelados {
  background-color: darkorange !important;
}

.excluidos {
  background-color: rgb(0, 102, 113) !important;
}

.retirado {
  background: rgb(208, 0, 0) !important;
}

.repasse:hover,
.retirado:hover {
  background: #949494 !important;
}

.repasse a,
.repasse p {
  color: #fff;
  text-decoration: none;
}

.div_descr {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.base-tagcolor {
  display: flex;
}

span.qdcolor {
  display: flex;
  width: 10px;
  border-radius: 2px;
  height: 10px;
  margin-right: 3px;
}

span.baasesapanqdcolor {
  display: flex;
  align-items: center;
  padding-right: 10px;
}

#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 200px;
}

#portotemplate .spinner div {
  background-color: #67302b !important;
}

/* HISTORICO */
.table-container {
  width: 100%;
  overflow: auto;
}

.table-historico {
  width: 100%;
}

.table-historico th {
  background: #ccc;
  padding: 5px;
  color: #3f3f3f;
  text-align: center !important;
}

.table-historico tr:nth-child(even) {
  background: #fff;
}

.table-historico tr:nth-child(odd) {
  background: #faf2d6;
}

.table-historico td {
  padding: 4px 8px;
  border: 1px solid #ededed;
  border-left: 0;
  border-right: 0;
  color: #343434;
  text-align: center !important;
}

.role-descricao {
  display: none;
}

@media (min-width: 800px) {
  .v--modal-box {
    width: 500px !important;
  }
}

#portotemplate ul,
#portotemplate ol {
  margin-top: 0;
  margin-bottom: -1px;
}

/* TABS ESTILO */
.tabs-component {
  padding: 2px 0 0;
}

.tabs-component-tabs {
  padding: 0;
  margin: 0;
  border: 0;
}

.tabs-component-panel h2 {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #67302b !important;
}

.tabs-component-panels {
  background: #f9f9f9;
  max-height: 318px;
  min-height: 318px;
  overflow: hidden;
  padding: 20px 27px;
  width: 100%;
  margin-top: 1px;
}

.tabs-component-tab {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0;
  width: 106px;
  text-align: center;
  margin-bottom: 3px;
  margin-top: 9px;
  font-size: 14px;
  font-weight: 600;
  transition: 0.3s;
  margin-right: 3px;
}

.tabs-component-tab a {
  /*height: 100%;*/
  display: block;
  padding: 8px;
  text-decoration: none !important;
}

.tabs-component-tab:hover {
  background: #dbdbdb;
  color: #535353;
}

.tabs-component-tab.is-active {
  box-shadow: 0px 3px 0px #67302b;
  border-color: #67302b;
}

.tabs-component-tab.is-disabled {
  display: none;
}

.title-h {
  color: #67302b;
  font-weight: 700 !important;
  font-size: 20px !important;
  background: #fff;
  padding-bottom: 10px;
  margin: 0 0 1px !important;
}

/* TABS ESTILO */

/* MEDIA QUERIES LAYOUT(RESPONSIVO) */
@media (max-width: 980px) {
  .tabs-component-tab {
    width: 95%;
    margin-left: 2.4%;
  }

  div#prevnext_lotes {
    position: absolute !important;
    top: -70px !important;
    right: 2px !important;
  }
}

@media (max-width: 900px) {
  .lt-chat {
    min-height: auto !important;
    margin-bottom: 80px !important;
  }

  #btn_enviamensagemchat {
    padding: 18px 10px;
  }

  button {
    margin: 0 !important;
  }
}

@media (max-width: 550px) {
  #btn_enviamensagemchat {
    padding: 9px 10px;
  }

  .lt-header {
    text-align: center;
  }

  h1.title-header-area {
    font-size: 25px !important;
    font-weight: 700 !important;
  }

  .style-descricao {
    max-height: 250px;
  }

  .role-descricao {
    display: initial;
    position: absolute;
    text-align: center;
    width: 83%;
    margin-top: 2rem;
    color: #e36159;
  }
}

.total-de-lances {
  color: #67302b;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}

.total-de-lances .count-lances {
  margin-top: 6px;
}

.iframe-container iframe {
  max-width: 100%;
  height: 275px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoteAberto.vue